import { Dispatch, FC, SetStateAction } from 'react'
import { StackLayout } from '@progress/kendo-react-layout'

import { SimulationBuildingInformationCard } from './SimulationBuildingInformationCard'
// import { useAppSelector } from '../../../stores'
import { BuildingInfoExpense, GetSimulationBuildingListReq } from '@gateway.Simulation'
import { ErrorMessage } from '../../../components/parts'

interface SimulationBuildingSearchResultListProps {
  skip: number
  apiSimulationBuildingGateway: (searchCondition: GetSimulationBuildingListReq) => void
  setNotificationMessages: Dispatch<SetStateAction<ErrorMessage[]>>
  setErrorMessages: Dispatch<SetStateAction<ErrorMessage[]>>
  buildingList: BuildingInfoExpense[]
  setSimulationBuildingListState: React.Dispatch<React.SetStateAction<BuildingInfoExpense[]>>
}

export const SimulationBuildingSearchResultList: FC<SimulationBuildingSearchResultListProps> = ({ apiSimulationBuildingGateway, setNotificationMessages, setErrorMessages, buildingList, setSimulationBuildingListState }) => {
  return (
    <StackLayout orientation="vertical" gap={5}>
      {buildingList.map((item) => {
        return (
          <SimulationBuildingInformationCard
            key={`${item.procurementNo ?? ''}-${item.subNo ?? ''}-${item.expense ?? ''}-${item.expenseSeq ?? ''}`}
            propsInfo={item}
            apiSimulationBuildingGateway={apiSimulationBuildingGateway}
            setNotificationMessages={setNotificationMessages}
            setErrorMessages={setErrorMessages}
            buildingList={buildingList}
            setSimulationBuildingListState={setSimulationBuildingListState}
          />
        )
      })}
    </StackLayout>
  )
}
